import React, { useMemo } from 'react';
import { Progress } from 'antd';
import { useDispatch } from 'react-redux';
import { toggleBootcampModal } from '@redux/actions/modalAction';
import { useCurrentWorkspace } from '@hooks/workspace';
import { useAuth } from '@hooks/useAuth';
import { onboardingPercentage } from '@helpers/onboardingSteps';
import { ReactComponent as BootcampIcon } from '@assets/icons/info/bootcamp.svg';

import './OnboardingProgressLevel.less';

export default function OnboardingProgressLevel() {
  const dispatch = useDispatch();
  const { user } = useAuth(false);
  const [currentWorkspace] = useCurrentWorkspace(false);

  const completed = useMemo(() => {
    const isContributor = currentWorkspace?.role === 'workspace://contributor';
    const { completed, total } = onboardingPercentage(
      isContributor,
      user?.completedOnboardingSteps || []
    );
    return { completed, total };
  }, [user?.completedOnboardingSteps, currentWorkspace?.role]);
  const percent = (100 / completed.total) * completed.completed;

  if (Math.ceil(percent) >= 100) return null;

  return (
    <div
      className="onboarding-progress-level"
      onClick={() => dispatch(toggleBootcampModal({ visible: true }))}
    >
      <div className="onboarding-progress-level-line">
        <Progress
          percent={percent}
          type="circle"
          showInfo={false}
          strokeColor="#fff"
          trailColor="rgba(255, 255, 255, 0.5)"
          strokeWidth={4}
        />
      </div>
      <div className="onboarding-progress-level-title">Bootcamp</div>
      <BootcampIcon />
    </div>
  );
}
